import React, { Component } from 'react';
import { Modal } from 'antd';

if (!window.rmes) window.rmes = {}

window.rmes.modal = Modal